import { render, staticRenderFns } from "./VerifyContactDetailsModal.vue?vue&type=template&id=1c0eaac8&scoped=true"
import script from "./VerifyContactDetailsModal.vue?vue&type=script&lang=js"
export * from "./VerifyContactDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0eaac8",
  null
  
)

export default component.exports